<template>
	<nav class="navbar text-center navbar-expand-md pb-2 mb-3">
		<div class="navbar-collapse justify-content-start content-filters-wrapper">
			<content-filter :contentTypes="compTypes" :type="'competition'">
				{{ lang=='he-IL'? 'מסגרת':'Competition' }}
			</content-filter>
			<!-- <content-filter :contentTypes="crowdTypes" :type="'crowd'">
				קהל
			</content-filter> -->
			<content-filter :contentTypes="tagTypes" :type="'tags'">
				{{ lang=='he-IL'? 'תגית':'Tag' }}
			</content-filter>
		</div>
	</nav>
</template>

<script>
import ContentFilter from './AppContentFilter.vue'

export default {
	components: {
		'content-filter': ContentFilter,
	},
	data() {
		return {
			compTypes: new Set(),
			crowdTypes: new Set(),
			tagTypes: new Set(),
			lang: 'he-IL'
		}
	},
	props: {
		isOpen: {
			type: Boolean,
			required: true,
			default: true
		},
	},
	mounted() {
		const that = this;
		this.emitter.on('gotPosts', function(posts) {
			posts.forEach(function(post) {
				if (post.competition) post.competition.forEach(comp => that.compTypes.add(comp.name))
				if (post.crowd) post.crowd.forEach(crowd => that.crowdTypes.add(crowd.name))
				if (post.tags) post.tags.forEach(tag => that.tagTypes.add(tag.name))
			})
			that.emitter.off('gotPosts')
		})
		this.lang = document.getElementsByTagName('html')[0].getAttribute('lang')
	}
};
</script>

<style>
.navbar-nav {
  border: 2px solid black;
  margin-inline-end: 0;
}
.nav-link {
  padding: .1rem 1rem !important;
  transition: all 400ms;
}
.filter-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;
  padding-inline: 0.5em !important;
}

.filter-wrapper.active {
  color: white;
  background-color: black;
}

.filter-wrapper > svg {
  transition: 300ms ease-in-out;
}
.filter-wrapper.active > svg {
  transform: rotate(360deg) scale(-1);
}


.date-picker {
	--pink: #F15794;
	background-color: #888;
	width: 236px;
	height: 160px;
	position: absolute;
	top: 2em;
	right: 0;
	z-index: 1;
	padding: 8px;
	border: 2px solid black;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-shadow: 0px 3px 6px #00000080;
}

.date-grid {
	display: flex;
	flex-direction: column;
	font-size: 0.8em;
	flex-grow: 1;
	color: black;
}

.date-grid .row {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	margin: 0;
}

.date-grid .row.weekdays::after {
	content: "";
	width: 700%;
	height: 1px;
	background-color: var(--pink);
	margin-block: 3px 6px;
}

.date-grid .row span {
	text-align: center;
}


.date-grid .row span.button {
	min-width: 1em;
	cursor: pointer;
	color: var(--pink);
}

.date-grid .row span.button.active {
	background-color: var(--pink);
	color: white;
	border-radius: 5px;
}

.buttons-wrapper {
	display: flex;
	justify-content: space-between;
}


.buttons-wrapper button {
	position: relative;
	color: var(--pink);
	background-color: white;
	border: 1px solid var(--pink);
	box-shadow: 0px 3px 6px #00000080;
	padding: 0 1em !important;
	transition: 300ms ease-in-out;
}

.buttons-wrapper button:focus {
	outline: none !important;
	background-color: white;
}

.buttons-wrapper button:nth-child(2):focus {
	background-color: var(--pink);
}

.buttons-wrapper button:nth-child(2) {
	background-color: var(--pink);
	color: white;
	border: 1px solid white;
}

.buttons-wrapper button:hover {
	bottom: 2px;
	background-color: white;
}

.buttons-wrapper button:nth-child(2):hover {
	background-color: var(--pink);
}

.close-button {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	right: 100%;
	top: 0;
	height: 1.2em;
	width: 1.2em;
	color: white;
	background: black;
	cursor: pointer;
}


@media only screen and (max-width: 768px) {
	.content-filters-wrapper {
		display: flex;
		gap: 1em;
	}
	.navbar-nav .nav-link {
		font-size: 1.4em;
	}

}
</style>

